document.addEventListener('DOMContentLoaded', () => {

  /* ---- CURSOR ---- */
  const co = document.getElementById('co'), ci = document.getElementById('ci');
  if (co && ci) {
    let mx=0,my=0,ox=0,oy=0;
    document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;ci.style.left=mx+'px';ci.style.top=my+'px';});
    (function ac(){ox+=(mx-ox)*.14;oy+=(my-oy)*.14;co.style.left=ox+'px';co.style.top=oy+'px';requestAnimationFrame(ac);})();
  }

  /* ---- CANVAS PARTICLE SYSTEM ---- */
  const canvas = document.getElementById('spark-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let W = canvas.width = window.innerWidth, H = canvas.height = window.innerHeight;
    window.addEventListener('resize',()=>{W=canvas.width=window.innerWidth;H=canvas.height=window.innerHeight;});

    class Spark{constructor(x,y){this.x=x;this.y=y;this.vx=(Math.random()-.5)*7;this.vy=(Math.random()-.5)*7-1.5;this.life=1;this.decay=.035+Math.random()*.05;this.r=Math.random()*2.5+.5;this.col=Math.random()>.35?'#ff1a00':'#ff7700';}
    tick(){this.x+=this.vx;this.y+=this.vy;this.vy+=.15;this.vx*=.97;this.life-=this.decay;}
    draw(){ctx.save();ctx.globalAlpha=this.life*.9;ctx.fillStyle=this.col;ctx.shadowColor=this.col;ctx.shadowBlur=8;ctx.beginPath();ctx.arc(this.x,this.y,this.r*this.life,0,Math.PI*2);ctx.fill();ctx.restore();}}

    class Ambient{constructor(){this.reset(true);}
    reset(init){this.x=Math.random()*W;this.y=init?Math.random()*H:H+10;this.vx=(Math.random()-.5)*.4;this.vy=-(Math.random()*.4+.15);this.r=Math.random()*1.2+.3;this.a=Math.random()*.35+.08;this.pulse=Math.random()*Math.PI*2;}
    tick(){this.x+=this.vx;this.y+=this.vy;this.pulse+=.04;if(this.y<-10)this.reset(false);}
    draw(){ctx.save();ctx.globalAlpha=this.a*(.7+.3*Math.sin(this.pulse));ctx.fillStyle='#ff0a0a';ctx.shadowColor='#ff0a0a';ctx.shadowBlur=6;ctx.beginPath();ctx.arc(this.x,this.y,this.r,0,Math.PI*2);ctx.fill();ctx.restore();}}

    class Bolt{constructor(){this.reset();}
    reset(){this.sx=Math.random()*W*.4+W*.3;this.sy=0;this.ex=this.sx+(Math.random()-.5)*350;this.ey=Math.random()*H*.5;this.life=1;this.decay=.055+Math.random()*.04;this.segs=this.gen();}
    gen(){const s=[],steps=8+Math.floor(Math.random()*7);for(let i=0;i<=steps;i++){const t=i/steps;s.push({x:this.sx+(this.ex-this.sx)*t+(Math.random()-.5)*50,y:this.sy+(this.ey-this.sy)*t});}return s;}
    tick(){this.life-=this.decay;}
    draw(){if(this.life<=0)return;ctx.save();ctx.globalAlpha=this.life*.55;ctx.strokeStyle='#ff2200';ctx.lineWidth=this.life*2;ctx.shadowColor='#ff0a0a';ctx.shadowBlur=15;ctx.beginPath();this.segs.forEach((s,i)=>i?ctx.lineTo(s.x,s.y):ctx.moveTo(s.x,s.y));ctx.stroke();ctx.restore();}}

    const sparks=[],ambients=Array.from({length:70},()=>new Ambient()),bolts=[];
    let lmx=0,lmy=0;
    document.addEventListener('mousemove',e=>{const spd=Math.hypot(e.clientX-lmx,e.clientY-lmy);if(spd>4)for(let i=0;i<Math.min(Math.floor(spd/5),6);i++)sparks.push(new Spark(e.clientX,e.clientY));lmx=e.clientX;lmy=e.clientY;});
    setInterval(()=>{if(bolts.length<3)bolts.push(new Bolt());},3000);
    (function rl(){ctx.clearRect(0,0,W,H);ambients.forEach(p=>{p.tick();p.draw();});for(let i=bolts.length-1;i>=0;i--){bolts[i].tick();bolts[i].draw();if(bolts[i].life<=0)bolts.splice(i,1);}for(let i=sparks.length-1;i>=0;i--){sparks[i].tick();sparks[i].draw();if(sparks[i].life<=0)sparks.splice(i,1);}requestAnimationFrame(rl);})();
  }

  /* ---- SVG ARCS ---- */
  const arcSvg = document.getElementById('arcSvg');
  if (arcSvg) {
    function spawnArc(){
      const x1=Math.random()*1400,y1=Math.random()*800;
      const x2=x1+(Math.random()-.5)*280,y2=y1+(Math.random()-.5)*280;
      const cx=(x1+x2)/2+(Math.random()-.5)*80,cy=(y1+y2)/2+(Math.random()-.5)*80;
      const p=document.createElementNS('http://www.w3.org/2000/svg','path');
      p.setAttribute('d',`M${x1},${y1} Q${cx},${cy} ${x2},${y2}`);
      p.setAttribute('stroke',Math.random()>.5?'#ff0a0a':'#ff5533');
      p.setAttribute('stroke-width',(Math.random()*1.2+.4).toString());
      p.setAttribute('fill','none');p.setAttribute('filter','url(#glow)');p.setAttribute('opacity','0');
      p.style.strokeDasharray=300;p.style.strokeDashoffset=300;
      arcSvg.appendChild(p);
      let start=null;
      (function step(ts){if(!start)start=ts;const pr=Math.min((ts-start)/320,1);p.style.strokeDashoffset=300*(1-pr);p.setAttribute('opacity',Math.sin(pr*Math.PI)*.8);if(pr<1)requestAnimationFrame(step);else setTimeout(()=>{try{arcSvg.removeChild(p);}catch(e){}},80);})();
    }
    setInterval(spawnArc,500);setInterval(spawnArc,800);setInterval(spawnArc,1300);
  }

  /* ---- 3D TILT + SHIMMER ---- */
  document.querySelectorAll('.pc').forEach(card=>{
    const inner=card.querySelector('.pc-inner');
    card.addEventListener('mousemove',e=>{
      const r=card.getBoundingClientRect();
      const dx=(e.clientX-r.left-r.width/2)/(r.width/2);
      const dy=(e.clientY-r.top-r.height/2)/(r.height/2);
      card.style.transform=`perspective(900px) rotateY(${dx*9}deg) rotateX(${-dy*9}deg) translateZ(12px)`;
      if(inner){inner.style.setProperty('--mx',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');inner.style.setProperty('--my',((e.clientY-r.top)/r.height*100).toFixed(1)+'%');}
    });
    card.addEventListener('mouseleave',()=>{card.style.transform='perspective(900px) rotateY(0deg) rotateX(0deg) translateZ(0)';});
  });

  /* ---- SCROLL REVEAL: removed, products show immediately ---- */

  /* ---- TEXT SCRAMBLE ---- */
  function scrambleEl(el){
    const orig=el.textContent;const chars='!<>-_\\[]{}—=+*^?#01IXZVQ';
    let frame=0;
    const q=orig.split('').map((c,i)=>({to:c,start:Math.floor(Math.random()*18),end:Math.floor(Math.random()*18)+10,cur:''}));
    function loop(){let out='',done=0;q.forEach(qi=>{if(frame>=qi.end){out+=qi.to;done++;}else if(frame>=qi.start){qi.cur=chars[Math.floor(Math.random()*chars.length)];out+=`<span style="color:var(--red3)">${qi.cur}</span>`;}else out+=qi.to===' '?' ':'·';});el.innerHTML=out;if(done<q.length){frame++;requestAnimationFrame(loop);}}
    requestAnimationFrame(loop);
  }
  const title=document.getElementById('arsenalTitle');
  if(title){new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting)scrambleEl(e.target);});},{threshold:.6}).observe(title);}

  /* ---- LOADER ---- */
  const ld=document.getElementById('loader');
  const ldLogo=document.querySelector('.ld-logo');
  if(ld&&ldLogo){
    let pct=0;
    const iv=setInterval(()=>{pct=Math.min(pct+2.5,100);ldLogo.style.setProperty('--pct',pct+'%');if(pct>=100)clearInterval(iv);},18);
    setTimeout(()=>{ld.classList.add('out');setTimeout(()=>{try{ld.remove();}catch(e){}},900);},1800);
  }

  /* ---- PRODUCT PAGE: GALLERY ---- */
  window.setMainImg = function(src, thumb) {
    const main = document.getElementById('mainImgEl');
    if (main) { main.src = src; }
    document.querySelectorAll('.prod-thumb').forEach(t => t.classList.remove('active'));
    if (thumb) thumb.classList.add('active');
  };

  /* ---- PRODUCT PAGE: VARIANT UPDATE ---- */
  const varData = document.getElementById('productVariants');
  const varSelect = document.getElementById('variantSelect');
  const priceEl = document.getElementById('prodPriceVal');
  if (varData && varSelect) {
    const variants = JSON.parse(varData.textContent);
    document.querySelectorAll('.opt-radio').forEach(r => {
      r.addEventListener('change', () => {
        const opts = {};
        document.querySelectorAll('.opt-group').forEach((g, i) => {
          const checked = g.querySelector('.opt-radio:checked');
          if (checked) opts[i] = checked.value;
        });
        const match = variants.find(v => v.options.every((o, i) => opts[i] === o || Object.keys(opts).length === 0));
        if (match) {
          varSelect.value = match.id;
          if (priceEl) priceEl.textContent = match.price_formatted;
          const addBtn = document.querySelector('.add-to-cart');
          if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT'; }
          if (match.image_src) {
            const mainImg = document.getElementById('mainImgEl');
            if (mainImg) mainImg.src = match.image_src;
          }
        }
      });
    });
  }

  /* ---- BIKE Q&A WALL ---- */
  (function bikeQA(){
    const form = document.getElementById('bqaForm');
    if (!form) return;

    const API_BASE = 'https://treadmoto-bike-qa.treadmoto.workers.dev';

    const photoInput = document.getElementById('bqaPhoto');
    const uploadEmpty = document.getElementById('bqaUploadEmpty');
    const previewImg = document.getElementById('bqaPreviewImg');
    const grid = document.getElementById('bqaGrid');
    const emptyMsg = document.getElementById('bqaEmpty');
    const statusEl = document.getElementById('bqaStatus');
    const adminToggle = document.getElementById('bqaAdminToggle');
    let pendingPhoto = null;
    let posts = [];
    let adminMode = sessionStorage.getItem('bqa_admin') === '1';
    let enteredPasscode = sessionStorage.getItem('bqa_admin_pass') || '';

    function updateAdminUI(){
      grid.classList.toggle('admin-mode', adminMode);
      if (adminToggle) adminToggle.classList.toggle('active', adminMode);
    }
    if (adminToggle){
      adminToggle.addEventListener('click', () => {
        if (adminMode){
          adminMode = false;
          enteredPasscode = '';
          sessionStorage.removeItem('bqa_admin');
          sessionStorage.removeItem('bqa_admin_pass');
          updateAdminUI();
          return;
        }
        const pass = prompt('Enter admin passcode to manage posts:');
        if (pass === null) return;
        enteredPasscode = pass;
        adminMode = true;
        sessionStorage.setItem('bqa_admin', '1');
        sessionStorage.setItem('bqa_admin_pass', pass);
        updateAdminUI();
      });
      updateAdminUI();
    }

    function esc(str){
      const d = document.createElement('div'); d.textContent = str||''; return d.innerHTML;
    }
    function timeAgo(ts){
      const s = Math.floor((Date.now()-ts)/1000);
      if (s<60) return 'JUST NOW';
      if (s<3600) return Math.floor(s/60)+'M AGO';
      if (s<86400) return Math.floor(s/3600)+'H AGO';
      return Math.floor(s/86400)+'D AGO';
    }
    function render(){
      if (!posts.length){ if(emptyMsg) emptyMsg.style.display=''; grid.querySelectorAll('.bqa-card').forEach(c=>c.remove()); return; }
      if (emptyMsg) emptyMsg.style.display='none';
      grid.querySelectorAll('.bqa-card').forEach(c=>c.remove());
      posts.forEach(p=>{
        const card = document.createElement('article');
        card.className = 'bqa-card';
        card.dataset.id = p.id;
        card.innerHTML = `
          <button type="button" class="bqa-card-delete" aria-label="Delete post" title="Delete post">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0-1 14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 6h16z"/></svg>
          </button>
          <div class="bqa-card-img"><img src="${p.img}" alt="${esc(p.bike)}" loading="lazy"></div>
          <div class="bqa-card-body">
            <div class="bqa-card-name">${esc(p.name)}</div>
            <div class="bqa-card-bike">${esc(p.bike)}</div>
            <p class="bqa-card-q">${esc(p.question)}</p>
            <div class="bqa-card-date">${timeAgo(p.ts)}</div>
          </div>`;
        grid.appendChild(card);
      });
    }

    async function fetchPosts(){
      try {
        const res = await fetch(API_BASE + '/posts');
        const data = await res.json();
        posts = data.posts || [];
        render();
      } catch (err) {
        if (statusEl) { statusEl.textContent = 'COULD NOT LOAD THE WALL — CHECK CONNECTION'; statusEl.className = 'bqa-status'; }
      }
    }

    grid.addEventListener('click', async (e) => {
      const btn = e.target.closest('.bqa-card-delete');
      if (!btn || !adminMode) return;
      const card = btn.closest('.bqa-card');
      if (!card) return;
      if (!confirm('Delete this post?')) return;
      const id = card.dataset.id;
      try {
        const res = await fetch(API_BASE + '/posts/delete', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, passcode: enteredPasscode }),
        });
        const data = await res.json();
        if (!res.ok){ alert(data.error || 'Delete failed.'); return; }
        posts = data.posts || [];
        render();
      } catch (err) {
        alert('Could not reach the server — try again.');
      }
    });

    photoInput.addEventListener('change', () => {
      const file = photoInput.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const maxW = 900;
          const scale = Math.min(1, maxW/img.width);
          const canvas = document.createElement('canvas');
          canvas.width = img.width*scale; canvas.height = img.height*scale;
          canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);
          pendingPhoto = canvas.toDataURL('image/jpeg', 0.7);
          previewImg.src = pendingPhoto;
          previewImg.hidden = false;
          uploadEmpty.style.display = 'none';
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const name = document.getElementById('bqaName').value.trim();
      const bike = document.getElementById('bqaBike').value.trim();
      const question = document.getElementById('bqaQuestion').value.trim();
      if (!pendingPhoto){ statusEl.textContent = 'ADD A PHOTO FIRST'; statusEl.className='bqa-status'; return; }
      if (!name || !bike || !question) return;

      const submitBtn = form.querySelector('.bqa-submit');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const res = await fetch(API_BASE + '/posts', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, bike, question, img: pendingPhoto }),
        });
        const data = await res.json();
        if (!res.ok){
          statusEl.textContent = (data.error || 'Something went wrong').toUpperCase();
          statusEl.className = 'bqa-status';
          return;
        }
        posts = data.posts || [];
        render();

        form.reset();
        pendingPhoto = null;
        previewImg.hidden = true;
        uploadEmpty.style.display = '';
        statusEl.textContent = 'POSTED TO THE WALL';
        statusEl.className = 'bqa-status ok';
        setTimeout(()=>{ statusEl.textContent=''; statusEl.className='bqa-status'; }, 3000);
      } catch (err) {
        statusEl.textContent = 'COULD NOT REACH THE SERVER — TRY AGAIN';
        statusEl.className = 'bqa-status';
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });

    fetchPosts();
    setInterval(fetchPosts, 45000);
  })();

});